export default __webpack_public_path__ + "src/assets/medium.5ad40553d5a94ff31a15fbce3009e737.svg";